import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';

export namespace DateFieldDefinition {
  export const TYPE = 'date';
}

/**
 * Field definition of type date
 * @typedef DateFieldDefinition
 * @property - type : type of the field.
 * @property - defaultValue : default value if value isn't set.
 * @property - validations : an optional object for defining rules about how a module definition can be instantiated.
 */
export type DateFieldDefinition = BaseFieldDefinition & {
  type: typeof DateFieldDefinition.TYPE;
  defaultValue?: string;
  validations?: {
    min?: string;
    max?: string;
  };
};

export const DateFieldDefinitionSchema: Schema<DateFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(DateFieldDefinition.TYPE),
      defaultValue: z.string().optional(),
      validations: z
        .object({
          min: z.string().optional(),
          max: z.string().optional()
        })
        .optional()
    })
  );
